export enum AlertInfo {
  QUESTION = 'question',
  INFO = 'info',
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning'
}
